export const certifications = [
  {
    id: 'iso-9001',
    title: 'ISO 9001:2015',
    subtitle: 'Quality Management System',
    description: 'International standard for quality management systems, ensuring consistent delivery of products and services that meet customer and regulatory requirements.',
    benefits: [
      'Enhanced customer satisfaction',
      'Consistent quality control',
      'Process optimization',
      'Continuous improvement framework',
    ],
    icon: '🏆',
    color: 'primary',
  },
  {
    id: 'iso-45001',
    title: 'ISO 45001:2018',
    subtitle: 'Occupational Health & Safety',
    description: 'Global standard for occupational health and safety management systems, demonstrating commitment to providing a safe and healthy workplace.',
    benefits: [
      'Worker safety protection',
      'Risk reduction',
      'Regulatory compliance',
      'Improved workplace culture',
    ],
    icon: '🛡️',
    color: 'secondary',
  },
  {
    id: 'iso-17025',
    title: 'ISO/IEC 17025:2017',
    subtitle: 'Testing & Calibration Laboratories',
    description: 'International standard for testing and calibration laboratories, ensuring technical competence and reliable results.',
    benefits: [
      'Technical competence validation',
      'International recognition',
      'Accurate test results',
      'Legal defensibility',
    ],
    icon: '🔬',
    color: 'primary',
  },
  {
    id: 'nabl',
    title: 'NABL Accreditation',
    subtitle: 'National Accreditation Board',
    description: 'Accreditation from NABL under ISO/IEC 17025, recognized by government agencies and courts for reliable testing services.',
    benefits: [
      'Government recognition',
      'Legal acceptance',
      'Quality assurance',
      'Market credibility',
    ],
    icon: '📋',
    color: 'secondary',
  },
  {
    id: 'cpcb',
    title: 'CPCB/MoEF&CC Approval',
    subtitle: 'Central Pollution Control Board',
    description: 'Authorization from Central Pollution Control Board and Ministry of Environment, Forest & Climate Change for environmental monitoring.',
    benefits: [
      'Regulatory authorization',
      'Environmental monitoring',
      'Compliance reporting',
      'Official recognition',
    ],
    icon: '🌍',
    color: 'primary',
  },
  {
    id: 'kspcb',
    title: 'KSPCB Consent',
    subtitle: 'State Pollution Control Board',
    description: 'Consent to Establish and Operate from Karnataka State Pollution Control Board for environmental testing facilities.',
    benefits: [
      'Legal operation',
      'State compliance',
      'Environmental clearance',
      'Operational authorization',
    ],
    icon: '✅',
    color: 'secondary',
  },
];

export const accreditationImportance = {
  title: 'Why Accreditation Matters',
  content: 'Accreditation and certification demonstrate our commitment to maintaining the highest standards of quality, accuracy, and reliability in environmental testing and consulting services. These credentials ensure that our testing methodologies, equipment calibration, and staff competence meet internationally recognized benchmarks. For our clients, this means legally defensible reports, regulatory acceptance, and confidence in decision-making based on our analysis. Our accreditations are regularly audited and renewed, ensuring continuous compliance with evolving standards and best practices in environmental science.',
  points: [
    'Legal validity and court acceptance of test reports',
    'International recognition and credibility',
    'Compliance with regulatory requirements',
    'Quality assurance and technical competence',
    'Customer confidence and trust',
    'Continuous improvement and monitoring',
  ],
};